// BosAI chat — client-side ceiling on one chat turn.
//
// The server aborts its bridge call after BOSAI_BRIDGE_TIMEOUT_MS (180 s default,
// app/api/bosai/chat/route.ts) and sends an error event; the SSE heartbeat keeps
// proxies from cutting the stream before that. If the server itself never settles
// (hung connection, lost error event), the widget aborts the fetch 10 s after the
// bridge would have, and the turn ends in the existing network-error text (+ retry).
// Fixed on purpose: the env override is server-only, the client cannot see it.
export const BOSAI_CHAT_CLIENT_TIMEOUT_MS = 180000 + 10000;

// Arms the ceiling on `ac`. timedOut() tells a ceiling abort apart from a deliberate
// one (unmount), which must stay silent; clear() must run when the turn settles.
export function armChatCeiling(ac: AbortController, ms: number = BOSAI_CHAT_CLIENT_TIMEOUT_MS) {
  let fired = false;
  const timer = setTimeout(() => {
    fired = true;
    ac.abort();
  }, ms);
  return {
    timedOut: () => fired,
    clear: () => clearTimeout(timer),
  };
}
